import { HONEYPOT_FIELD_NAME } from "../constants/formHoneypot";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

/** Hidden field for bot detection; must remain empty for real users. */
export function HoneypotField({ value, onChange }: Props) {
  return (
    <div
      className="absolute left-[-9999px] h-px w-px overflow-hidden opacity-0"
      aria-hidden="true"
    >
      <label htmlFor={HONEYPOT_FIELD_NAME}>Company website</label>
      <input
        type="text"
        id={HONEYPOT_FIELD_NAME}
        name={HONEYPOT_FIELD_NAME}
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
